import Channel from '@/clients/toya/classes/channels/channel'
import Program from '@/shared/classes/epg/program/program'
import { useEPGStore, useFilterStore, useTVStore } from '@/shared/store'
import { FilterCategory } from '@/shared/store/types'
import { ExtendedEpgElement } from '@/types/epg/Epg'
import { useTranslation } from 'react-i18next'
import { sortObjectsByName } from '@/shared/lib'

const useCategoriesForFiltering = () => {
    const { setFilterCategories } = useFilterStore()
    const { epgData } = useEPGStore()
    const { channelsData } = useTVStore()
    const { t: translate } = useTranslation()
    const getCategoriesForFiltering = () => {
        const categories: FilterCategory[] = []

        channelsData.forEach((channel: Channel) => {
            const { cat, list, id } = channel

            if (!cat || !list) return

            const allCategoriesList = new Set([...cat, ...list])

            const epgElement = epgData.find(
                (element: ExtendedEpgElement) => element.channelId === id
            )

            if (epgElement) {
                const { programs } = epgElement
                programs.forEach((program: Program) => {
                    const programCat = translate(program.genre)
                    allCategoriesList.add(programCat)
                })
            }

            allCategoriesList.forEach((allCategoriesList) => {
                const existingObject = categories.find(
                    (obj) => obj.name === allCategoriesList
                )

                if (existingObject) {
                    existingObject.itemsAmount += 1
                } else {
                    categories.push({
                        name: allCategoriesList,
                        itemsAmount: 1,
                    })
                }
            })
        })
        const categoriesArray = Array.from(categories)
        const sortedArray = sortObjectsByName(
            categoriesArray,
            (obj) => obj.name
        )
        sortedArray.unshift({
            name: translate('genreFavorites'),
            itemsAmount: 0,
        })

        const filters = sortedArray.filter(
            (item) => item.name !== 'kids' && Boolean(item.name)
        )
        setFilterCategories(filters)
    }

    return { getCategoriesForFiltering }
}

export { useCategoriesForFiltering }
